<template>
	<div class="event-news">
		<div class="page-container">
			<PageTitle ch="最新消息" en="News"></PageTitle>
			<div class="news">
				<div class="n-item" v-for="(news, key) in newsDataR" :key="key">
					<!-- <div class="cover-img"></div> -->
					<div class="right">
						<div class="time">
							<div class="year">{{timeConvert(news.date, true)}}</div>
							<div class="date">{{timeConvert(news.date, false)}}</div>
						</div>
						<h2 class="title">{{news.title}}</h2>
						<router-link :to="'/news/'+ news.id" class="read-more">
							<span class="desktop">看更多</span>
							<img src="@/assets/event/leftArrow.svg" alt="">
						</router-link>
					</div>

				</div>
				<el-pagination class="pagination" @current-change="changeCurrentPage" background large layout="prev, pager, next" :total="totalNews">
				</el-pagination>
			</div>

		</div>
	</div>
</template>

<script>
import PageTitle from '@/components/page_title'
import ArtistData from '../../../static/assets/program/artistData.json'
import { mapActions, mapState } from 'vuex';

export default {
  metaInfo: {
    title: '利澤國際偶戲藝術村'
  },
  name: 'eventNews',
  data() {
    return {
      isShowPop: false,
      news: {},
      currentPop: {},
      newsDataR: [],
      totalNews: 0
    }
  },
  mounted() {
    this.getNewsDataByPage()
  },
  methods: {
    ...mapActions([
      'getNews'
    ]),
    openSlide: function (data) {
      this.currentPop = data
      this.isShowPop = true
      $('html,body').scrollTop(0)
    },
    closeSlide: function () {
      this.isShowPop = false
    },
    timeConvert: function (timestamp, onlyYear) {
      let date = new Date(timestamp)
      if (onlyYear) {
        return date.getFullYear()
      } else {
        return `${date.getMonth() + 1}/${date.getDate()}`
      }
    },
    changeCurrentPage(page) {
      this.$router.push({ query: { pages: page } })
    },
    getNewsDataByPage() {
      let page = this.$route.query.pages ? this.$route.query.pages : 1
      this.getNews({ offset: (page - 1) * 10, length: 10 })
    }
  },
  computed: {
    ...mapState([
      'newsData'
    ])
  },
  watch: {
    newsData: function () {
      this.totalNews = this.newsData.total
      this.newsDataR = this.newsData.list
    },
    $route() {
      this.getNewsDataByPage()
    }
  },
  components: {
    PageTitle,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../../stylesheet/base.sass'
  @import '../../stylesheet/layout.sass'
  .page-container
    padding-bottom: 100px
    .pagination
      +flexLayout('center', 'row')
      margin: 50px auto
  .event-news
    // position: relative
    min-height: 1000px

    .news
      +flexLayout('center', 'col')
      max-width: 1024px
      width: 100%
      margin: 0 auto
      padding: 0 10px
      .n-item
        +flexLayout('between', 'row')
        width: 100%
        .cover-img
          +size(114px, 64px)
          background-image: url("../../assets/about/img_about_01.png")
          background-size: cover
          background-position: center
          @media screen and (max-width: 996px)
            display: none
        .right
          +flexLayout('between', 'row')
          flex: 1
          border: 1px solid #01b6e2
          border-width: 0 0 1px 0
          .time
            +flexLayout('start', 'col')
            color: #636363
            font-weight: 600
            padding: 26px
            line-height: 1.3
            width: 150px
            .year
              font-size: 20px
            .date
              font-size: 35px
          .title
            flex: 1
            color: #222222
            font-size: 24px
            letter-spacing: normal
            font-weight: bold
            border: 1px solid #01b6e2
            border-width: 0 0 0 1px
            padding: 26px 26px 26px
          .read-more
            +flexLayout('center', 'row')
            font-size: $font-size-3
            color: white
            width: 113px
            height: 38px
            border-radius: 100px
            background-color: #01b6e2
            opacity: 0.7
            cursor: pointer
            &:hover
              opacity: 1
            img
              margin-left: 3px
  @media screen and (max-width: 996px)
    .event-news
      .news
        .n-item
          .right
            .time
              padding: 5px
              width: 80px
              .year
                font-size: 14px
              .date
                font-size: 24px
            .title
              padding: 10px
            .read-more
              width: initial
              padding: 5px 10px
      .cover-img
        display: none
      .desktop
        display: none


</style>



// WEBPACK FOOTER //
// src/pages/event/event_news.vue